export const ActionTypes={
    SET_TOKEN :"SET_TOKEN"
}